import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import AppBarContainer from 'base/containers/AppBarContainer';
import Box from '@material-ui/core/Box';
import Footer from 'base/ui_components/Footer';
import { isMobileMedia } from 'utils/media';
import MenuPageFooter from 'menus/containers/MenuPageFooter';
import GridContainer from 'base/ui_components/GridContainer';
import Hero from 'base/ui_components/Hero';
import SecondaryCta from 'base/components/SecondaryCta';
import { DEFAULT_LAYOUT_PADDING } from 'base/style_mixins/layoutPadding';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

class BaseLayout extends React.PureComponent {
  static propTypes = {
    children: CHILDREN_PROPTYPES.isRequired,
    mobileFooter: CHILDREN_PROPTYPES,
    hideHeroOnMobile: PropTypes.bool,
    hideNav: PropTypes.bool,
    hideBrandFooterOnMobile: PropTypes.bool,
    hideMobileStickyCtaFooter: PropTypes.bool,
    heroSrc: PropTypes.string,
    heroAlt: PropTypes.string,
    layoutPadding: PropTypes.object,
    isModal: PropTypes.bool,
    isFetching: PropTypes.bool,
    utmFooterLink: PropTypes.string,
    heroContent: CHILDREN_PROPTYPES
  };

  static defaultProps = {
    mobileFooter: <MenuPageFooter />,
    layoutPadding: DEFAULT_LAYOUT_PADDING
  };

  renderNav = () => {
    if (this.props.hideNav) {
      return null;
    }
    return <AppBarContainer />;
  };

  renderMobileFooter = () => {
    if (this.props.hideMobileStickyCtaFooter || this.props.isFetching) {
      return null;
    }

    return this.props.mobileFooter;
  };

  renderHero() {
    const { hideHeroOnMobile, heroSrc, heroAlt, heroContent } = this.props;

    const shouldDisplayOnMobile = !(isMobileMedia() && hideHeroOnMobile);
    const noHeroContent = !!(heroSrc || heroContent);

    // couple of cases where we don't display hero
    // 1) if current viewport is mobile, and the prop has been set to hide on mobile
    // 2) if there is no hero content, which can include an image, or other specified
    // hero content (like a dom node containing a search bar on location list page)
    const shouldDisplayHero = shouldDisplayOnMobile && noHeroContent;

    if (shouldDisplayHero) {
      return (
        <Hero src={heroSrc} alt={heroAlt}>
          {heroContent}
        </Hero>
      );
    }
    return null;
  }

  render() {
    const {
      layoutPadding,
      isModal,
      isFetching,
      hideBrandFooterOnMobile,
      children,
      utmFooterLink
    } = this.props;
    return (
      <Box pt={isModal ? {} : { xs: 7, sm: 8 }}>
        {this.renderNav()}
        {this.renderHero()}
        <GridContainer {...layoutPadding}>
          <div>{children}</div>

          {!isFetching && isFetching !== undefined && (
            <Footer hideBrandFooterOnMobile={hideBrandFooterOnMobile}>
              <SecondaryCta
                label="Powered By Bentobox"
                component="a"
                href={utmFooterLink}
                dataTestId="footer"
              />
            </Footer>
          )}
          {this.renderMobileFooter()}
        </GridContainer>
      </Box>
    );
  }
}

const mapStateToProps = state => {
  const utmFooterLink = get(state.account, 'utm_footer_link', '');
  return {
    utmFooterLink
  };
};

export default connect(mapStateToProps)(BaseLayout);
